module.exports = {
      id: "icon-user-usage",
      viewBox: "0 0 50 50",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-user",
      toString: function () {
        return this.url;
      }
    }